module.exports = __webpack_public_path__ + "static/media/mt.dd04a697.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/mt.svg
// module id = 1111
// module chunks = 0